<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    group
                </mat-icon>
                <app-search-marquee #searchMarquee [searchRequestTypeEnum]="searchRequestTypeEnum"
                                    [searchRequestTileComponentTypeName]="searchRequestTileComponentTypeName"
                                    [disabled]="isSearchMarqueeDisabled">
                </app-search-marquee>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                <!--Enter search criteria to locate groups-->
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <br />
                <!--<mat-tab-group *ngIf="searchResult.length > 0">
                    <mat-tab label="Results">
                        <br />-->
                        <table mat-table [dataSource]="searchResultDatasource" class="search-result mat-elevation-z8" matSort>
                            <ng-container matColumnDef="Avatar">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let group" (click)="editItem(group.GroupId)">
                                    <!--<app-image srcPath="{{ group.AvatarBlobPath == null ? appService.defaultImageUri : group.AvatarBlobPath }}" isApiImage="{{ group.AvatarBlobPath == null ? 'false' : 'true' }}" (click)="editItem(group.GroupId)" class="margin-wide-right nudge-down-small" className="app-image-extra-small app-image-circle"></app-image>-->
                                    <mat-icon class="material-symbols-outlined">
                                        group
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                                <td mat-cell *matCellDef="let group" (click)="editItem(group.GroupId)">
                                    {{ group.Name }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Delete">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let group">
                                    <button mat-button (click)="deleteItem(group.GroupId, group.Name)">
                                        <mat-icon class="material-symbols-outlined">
                                            delete_forever
                                        </mat-icon>
                                    </button>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    <!--</mat-tab>
                </mat-tab-group>-->
            </form>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

